// Display projections use `url` for CDN previews; raw relay results use `url`
// for originals. Preserve the separate original field when crossing that boundary.
export function imageOriginalURL(image = {}) {
  const explicit = String(image.originalUrl || image.original_url || '').trim()
  const candidate = explicit || String(image.remoteUrl || image.remote_url || image.url || '').trim()
  try {
    const parsed = new URL(candidate)
    if (!['https:', 'http:'].includes(parsed.protocol) || parsed.username || parsed.password) return ''
    if (!explicit) {
      const domestic = String(image.chinaUrl || image.china_url || '').trim()
      if (domestic && new URL(domestic).hostname.toLowerCase() === parsed.hostname.toLowerCase()) return ''
    }
    return candidate
  } catch {
    return ''
  }
}
